import format from "date-fns/format";

const columns = [
  { Header: "ID", accessor: "_id" },
  { Header: "Project Number", accessor: "project_number" },
  { Header: "Name", accessor: "name" },
  { Header: "Description", accessor: "description" },
  { Header: "Department", accessor: "department" },
  { Header: "Category", accessor: "category" },
  { Header: "Call Type", accessor: "callType" },
  { Header: "Contract", accessor: "contract" },
  { Header: "Customer", accessor: "customer" },
  { Header: "Project Manager", accessor: "projectManager" },
  { Header: "Salesperson", accessor: "salesperson" },
  { Header: "Primary Resource", accessor: "primaryResource" },
  { Header: "Secondary Resource", accessor: "secondaryResource" },
  {
    Header: "Start Date",
    accessor: "start_date",
    Cell: ({ value }) =>
      value ? format(new Date(value), "MM/dd/yyyy kk:mm") : "--"
  },
  {
    Header: "End Date",
    accessor: "end_date",
    Cell: ({ value }) =>
      value ? format(new Date(value), "MM/dd/yyyy kk:mm") : "--"
  },
  { Header: "Budget Amount", accessor: "budget_amount" },
  { Header: "Budget Hours", accessor: "budget_hours" },
  { Header: "Rate", accessor: "rate" },
  { Header: "Requestor Required", accessor: "requestor_required" },
  { Header: "Department Category", accessor: "departmentCategory" },
  {
    Header: "Department Category Description",
    accessor: "departmentCategoryDescription"
  },
  { Header: "Created By", accessor: "created_by" },
  { Header: "Modified By", accessor: "modified_by" },
  {
    Header: "Created On",
    accessor: "created_on",
    Cell: ({ value }) =>
      value ? format(new Date(value), "MM/dd/yyyy kk:mm") : "--"
  },
  {
    Header: "Modified On",
    accessor: "modified_on",
    Cell: ({ value }) =>
      value ? format(new Date(value), "MM/dd/yyyy kk:mm") : "--"
  }
];

export default columns;
